// 公用接口
import { get, post } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
const { testwikidatacenter, homeClient } = apiList

export default (axios) => ({
  // 获取评论列表[单个交易商的评论总列表,聚合]
  GetTraderCommentsList: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/comment/index/list-v1`, params),
  // 获取评论列表[单个交易商的评论总列表,tab切换]
  GetTraderCommentsSwichList: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/comment/index/switch-v1`, params),
  // 获取评论详情
  GetCommentsDetail: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/comment/index/detail-v1`, params),
  // 获取评论详情
  GetCommentsDetailClient: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/comment/index/detail-v1`, params),
  // 获取评论的回复列表
  GetCommentsReply: (params = {}) => get(axios, `${homeClient}/comment/tokendetail`, params),
  // 获取评论列表[交易商详情页的评论列表]
  GetMostweekComments: (params = {}) => get(axios, `${homeClient}/comment/mostweek`, params),
  // 发表评论
  Publish: (params = {}) => post(axios, `${homeClient}/wikifxweb-v1/comment/index/publish-v1`, params),
  // 回复评论
  commentReply: (params = {}) => post(axios, `${homeClient}/wikifxweb-v1/comment/index/reply-v1`, params),
  // 上传图片
  Uploadimage: (params = {}) => post(axios, `${homeClient}/wikifxweb-v1/comment/image/upload-v1`, params),
  // 翻译评论
  FanYiComments: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/comment/trans/init-v1`, params),
  // 1：点赞数+1或-1 2：踩数+1或-1 3：分享数+1 4：浏览量数+1
  commentApplaud: (params = {}) => post(axios, `${homeClient}/wikifxweb-v1/comment/stastic/init-v1`, params),
  // 举报原因列表
  getExposureReasons: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/comment/report-v1`, params),
  // 发布举报
  postExposureReportPublish: (params = {}) => post(axios, `${homeClient}/wikifxweb-v1/comment/report/publish-v1`, params)
})
